import { Message, Topic } from "@visioni/a3s-messages";
import z from "zod/v4";

export const LineCrossScenarioStatus = z.object({
  scenarioUuid: z.string(),
  scenarioName: z.string(),
});
export type LineCrossScenarioStatus = z.infer<typeof LineCrossScenarioStatus>;

export const LineCrossScenarioStatusEvent = Message({
  typ: "LineCrossScenarioStatusEvent",
  ver: "1",
  dat: z.object({ scenarios: z.array(LineCrossScenarioStatus) }),
});
export type LineCrossScenarioStatusEvent = z.infer<typeof LineCrossScenarioStatusEvent>;

/** `G2/{tenant}/{site}/{asset}/{camera}/traffic-flow-status/events` */
export const LineCrossScenarioStatusTopic = Topic.camera("traffic-flow-status", "events");
